<template>
  <div class="is-user-avatar">
    <img
      :src="newAvatar"
    >
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'UserAvatar',
  props: {
    avatar: {
      type: String,
      default: null
    }
  },
  setup (props) {
    const newAvatar = computed(() => props.avatar ? props.avatar : null)

    return {
      newAvatar
    }
  }
}
</script>
